//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  data() {
    return {
      key: ''
    }
  },
  watch: {
    $route (to, from) {
      this.key = to.fullPath
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue